import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography} from "@mui/material";
import Button from "@mui/material/Button";

function DropCalendarDialog(props) {
  const {dialogVisible, title, description, items, dismissDialog} = props

  return (
    <div>
      <Dialog open={dialogVisible} onClose={dismissDialog}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography fontSize={14} fontStyle={'italic'}>{description}</Typography>
            {items?.map((row, ix) => {
              return (<Typography fontSize={12} fontWeight={600}>{row}</Typography>)
            })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant={"outlined"} onClick={dismissDialog}>{'OK'}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export {DropCalendarDialog}